<div class="code-container" *ngIf="!!snippet.type">
  <code-area [isString]="true" [parent]="snippet" [type]="snippet.type" [value]="snippet.code" key="code"></code-area>

  <div class="button-right-container">
    <button (click)="cancel()" class="ibexfusion-raised-button" mat-button>{{'general.cancel' | translate}}</button>
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</div>
